import "lazysizes";
import mobileButton from "../modules/mobileButton";

mobileButton();
